.separator {
  background: #c7d8df;
  height: 1px;
  margin: var(--space-xl);
  border: 0;
  flex-shrink: 0;
}
